import { useCallback } from "react";
import Endpoint from "../Endpoint";

export const useAvatar = () => {
    const generateLocalSvg = useCallback((name = "User", size = 256) => {
        const initials = name
            .split(" ")
            .map(n => n[0])
            .join("")
            .toUpperCase();

        const bg = "#ffffff";
        const color = "#e63946";

        const svg = `
            <svg width="${size}" height="${size}" xmlns="http://www.w3.org/2000/svg">
                <rect width="100%" height="100%" fill="${bg}"/>
                <text x="50%" y="50%" dy=".35em"
                      font-family="Poppins, sans-serif"
                      font-size="${size * 0.4}"
                      fill="${color}"
                      text-anchor="middle">
                    ${initials}
                </text>
            </svg>
        `;

        return `data:image/svg+xml;base64,${btoa(svg)}`;
    }, []);

    const getAvatar = useCallback((url = null, name = "User") => {
        if (!url) {
            return generateLocalSvg(name);
        }

        // 👉 Si NO empieza con http y SI empieza con "/"
        if (!url.startsWith("http") && url.startsWith("/")) {
            return `${Endpoint}${url}`;
        }

        // Caso normal
        return url;
    }, [generateLocalSvg]);

    return { getAvatar };
};
